import {GetInstantOfferAdsError} from './GetInstantOfferAdsError.js'

export class GetInstantOfferGenericAdsError extends GetInstantOfferAdsError {}
